import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.48 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.3 6.94h13.61c.17 0 .3-.13.3-.3s-.13-.3-.3-.3H1.3c-.16 0-.3.13-.3.3s.14.3.3.3zm0-3.15h13.61c.17 0 .3-.13.3-.3s-.13-.3-.3-.3H1.3c-.16 0-.3.14-.3.3s.14.3.3.3zM6.6 9.5H1.3c-.17 0-.3.13-.3.3s.13.3.3.3h5.3c.17 0 .3-.13.3-.3s-.13-.3-.3-.3zm-.51 3.16H1.3c-.17 0-.3.13-.3.3s.13.3.3.3h4.78c.17 0 .3-.13.3-.3s-.13-.3-.29-.3zm9.27 1.6-1.45-1.05c.37-.59.54-1.3.42-2.04-.26-1.62-1.8-2.74-3.42-2.46-1.62.26-2.72 1.8-2.46 3.42a2.982 2.982 0 0 0 3.42 2.46c.67-.11 1.24-.44 1.67-.9L15 14.75c.05.04.11.06.18.06.09 0 .19-.04.24-.12.1-.14.07-.33-.06-.43zM11.77 14a2.39 2.39 0 0 1-2.73-1.97 2.378 2.378 0 0 1 2.35-2.76 2.381 2.381 0 0 1 .38 4.73z"
    }, null, -1)
  ])))
}
export default { render };